export default class TitleEdition extends Backbone.View {
    constructor() {
        super(...arguments);
        this.render();
    }

    render() {
        let node = $(
            `<div class="title-edition" lang="${
                this.model.languageCode
            }" dir="${this.model.dir}">${this.model.get('edition')}</div>`
        );
        this.setElement(node);
    }
}
